import { CLOSE_HELP, SHOW_HELP, RESET_HELP_SECTION_TOPIC } from '@app/actions/_types';

const initialHelpState = {
  activated: false,
  currentHelpSection: null,
  currentHelpSectionTopic: null,
};

export default (state = initialHelpState, { type, payload }) => {
  switch (type) {
    case CLOSE_HELP:
      return {
        ...state,
        activated: false,
        currentHelpSection: null,
        currentHelpSectionTopic: null,
      };
    case SHOW_HELP: {
      const { helpSection, helpTopic } = payload;
      return {
        ...state,
        activated: true,
        currentHelpSection: helpSection,
        currentHelpSectionTopic: helpTopic,
      };
    }
    case RESET_HELP_SECTION_TOPIC:
      return {
        ...state,
        currentHelpSectionTopic: null,
      };
    default:
      return state;
  }
};
